import {
  type ID,
  LibraryActions,
  type LibraryHydratePayload,
  type LibraryUpsertPayload,
} from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { call, put, select } from 'redux-saga/effects'

import { getProjectLibrary } from '@/services/library'
import { selectReferencedLibraryIds } from '../selectors'
import { ensureLibraryColors } from './ensureLibraryColors'
import { purgeMissingSymbols } from './purgeMissingSymbols'

/**
 * Re-reads the items the refs of the project point at. What came back is
 * upserted, what did not is gone from the library — and then from the project.
 */
export function* syncProjectLibrary() {
  const referenced: ID[] = yield select(selectReferencedLibraryIds)
  const projectId: string | null = yield select(
    migrationProjectSelector.getProjectId
  )

  if (referenced.length === 0 || !projectId) {
    return
  }

  try {
    const lists: LibraryHydratePayload = yield call(
      getProjectLibrary,
      projectId
    )
    const items = lists.symbol ?? []
    const found = new Set(items.map(({ id }) => id))
    const missing = referenced.filter((id) => !found.has(id))

    yield put(
      LibraryActions.upsert({ kind: 'symbol', items } as LibraryUpsertPayload)
    )

    if (missing.length > 0) {
      yield put(LibraryActions.remove({ kind: 'symbol', ids: missing }))
    }

    yield call(ensureLibraryColors)
    yield call(purgeMissingSymbols)
  } catch (error) {
    console.error('Failed to re-read the referenced library items', error)
  }
}
